import { createAction } from '@reduxjs/toolkit';
import {
  Area,
  CellPosition,
  GridEntity,
  SelectionCell,
  SelectionOperationType,
  Sheet,
} from '../../../types';
import { DataDirection } from '../../../../core/types/ui/position';

const SHEET_VIEW_NAMESPACE = 'sheetsManager/view';

interface CalculateSheetViewport {
  sheetId: string;
  width: number;
  height: number;
  sheet?: Sheet;
}
export const calculateSheetViewport = createAction<CalculateSheetViewport>(
  `${SHEET_VIEW_NAMESPACE}/viewportCalc`
);

interface AdjustNonFrozenViewportWithFreeze {
  sheetId: string;
  adjustCols?: boolean;
  adjustRows?: boolean;
  windowWidth: number;
  windowHeight: number;
}
export const adjustNonFrozenViewportWithFreezeAc =
  createAction<AdjustNonFrozenViewportWithFreeze>(
    `${SHEET_VIEW_NAMESPACE}/adjustNonFrozenIndex`
  );

interface LoadSheet {
  sheetId: string;
  windowId: string;
}
export const loadSheet = createAction<LoadSheet>(
  `${SHEET_VIEW_NAMESPACE}/loadSheet`
);

export const loadSheetGroup = createAction<string>(
  `${SHEET_VIEW_NAMESPACE}/loadSheetGroup`
);

interface MouseOnCell {
  sheetId: string;
  cell: SelectionCell;
  position: CellPosition;
  // cellArea: Area;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  fromMouseMove?: boolean;
  focusCellInViewport?: boolean;
  windowWidth?: number;
  windowHeight?: number;
  forContextMenu?: boolean;
}
export const startCellSelection = createAction<MouseOnCell>(
  `${SHEET_VIEW_NAMESPACE}/startCellSelection`
);

export const cellHover = createAction<MouseOnCell>(
  `${SHEET_VIEW_NAMESPACE}/cellHover`
);
export const stopCellSelection = createAction<string>(
  `${SHEET_VIEW_NAMESPACE}/stopCellSelection`
);

interface MouseMoveWithSelection extends Pick<MouseOnCell, 'ctrlKey'> {
  clientX: number;
  clientY: number;
  sheetId: string;
  freezedColsSum: number; // zoom adjusted sum
  freezedRowsSum: number; // zoom adjusted sum
}
export const mouseMoveWithSelection = createAction<MouseMoveWithSelection>(
  `${SHEET_VIEW_NAMESPACE}/mouseMoveWithSelection`
);

interface EnterKeyOnCell {
  sheetId: string;
  windowWidth: number;
  windowHeight: number;
}
export const enterKeyOnCell = createAction<EnterKeyOnCell>(
  `${SHEET_VIEW_NAMESPACE}/enterKey`
);

interface ArrowKeyOnCell {
  key: string;
  sheetId: string;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  windowWidth: number;
  windowHeight: number;
}
export const arrowKeyOnCell = createAction<ArrowKeyOnCell>(
  `${SHEET_VIEW_NAMESPACE}/arrowKeys`
);

interface StartSelectionInteraction {
  sheetId: string;
  op?: SelectionOperationType;
  clientX: number;
  clientY: number;
  freezedColsSum: number; // zoom adjusted sum
  freezedRowsSum: number; // zoom adjusted sum
  positionIndex?: number;
}
export const startSelectionInteraction =
  createAction<StartSelectionInteraction>(
    `${SHEET_VIEW_NAMESPACE}/startSelectionInteraction`
  );

export const updateSelectionForContextMenu =
  createAction<StartSelectionInteraction>(
    `${SHEET_VIEW_NAMESPACE}/updateSelectionForCM`
  );

interface ScrollViewportByButtonsAc {
  sheetId: string;
  windowWidth: number;
  windowHeight: number;
  direction: DataDirection;
  entityType?: GridEntity;
  expectedIndex?: number;
  skipIndexes?: number;

  scrollHorizontally?: boolean;
  scrollVertically?: boolean;
}
export const scrollViewportByButtons = createAction<ScrollViewportByButtonsAc>(
  `${SHEET_VIEW_NAMESPACE}/scrollByButtons`
);

type SetViewportFromScrollbarPosition = Pick<
  ScrollViewportByButtonsAc,
  'sheetId' | 'windowWidth' | 'windowHeight' | 'entityType' | 'expectedIndex'
>;
export const setViewportFromScrollbarPosition =
  createAction<SetViewportFromScrollbarPosition>(
    `${SHEET_VIEW_NAMESPACE}/setViewportFromScrollbar`
  );

interface OpenCellEditor {
  sheetId: string;
  position?: CellPosition;
  key?: string
}

export const openCellEditor = createAction<OpenCellEditor>(
  `${SHEET_VIEW_NAMESPACE}/openCellEditor`
);
